import { useForm, useFormContext } from 'react-hook-form';
import { CustomerType, SessionContextInput } from 'gql/__generated/vp-apollo';
import { useSubmissionLock } from 'hooks/form/useSubmissionLock';

export const useCustomerTypeSelectionForm = () =>
    useForm<Pick<SessionContextInput, 'customerType'>>({
        defaultValues: {
            customerType: CustomerType.Existing,
        },
    });

export const useCustomerTypeSelectionFormContext = () => {
    const { handleSubmit, formState } = useFormContext<Pick<SessionContextInput, 'customerType'>>();
    const lockSubmission = useSubmissionLock(formState);

    return {
        handleSubmit,
        lockSubmission,
    };
};
